import { createActions, createReducer } from 'reduxsauce';
import {
	set, get, cloneDeep, isEmpty, forEach,
} from 'lodash';

export { default as thunks } from './thunks';

/* ------------- Initial State ------------- */
export const INITIAL_STATE = {
	activeOfficer : {},
	loaders       : {
		activeOfficer : false,
	},
};

/* ------------- Types and Action Creators ------------- */
export const { Types, Creators } = createActions({
	receiveData   : ['collection'],
	updateLoaders : ['loader', 'value'],
	resetData     : ['property'],

}, { prefix : '@officers/' });

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
	[Types.RECEIVE_DATA] : (state, { collection }) => {
		if (!isEmpty(collection)) {
			const newState = cloneDeep(state);

			forEach(collection, ({ property, value }) => {
				set(newState, property, value);
			});

			return newState;
		}
		return state;
	},

	[Types.UPDATE_LOADERS] : (state, { loader, value }) => {
		const newState = cloneDeep(state);

		set(newState, ['loaders', loader], value);

		return newState;
	},

	[Types.RESET_DATA] : (state, { property }) => {
		const newState = cloneDeep(state);

		set(newState, property, get(INITIAL_STATE, property));

		return newState;
	},
});

export default Creators;
